import { render, staticRenderFns } from "./ProjectCreationComponent.vue?vue&type=template&id=0275826b&scoped=true&"
import script from "./ProjectCreationComponent.vue?vue&type=script&lang=ts&"
export * from "./ProjectCreationComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0275826b",
  null
  
)

export default component.exports